import prefill from './prefill';

export default prefill({
  none: {},
  black: {},
  blue: {},
  green: {},
  pink: {},
  red: {},
  yellow: {},
  /* eslint-disable quote-props */
  'handleless_black': {},
  'handleless_blue': {},
  'handleless_green': {},
  'handleless_pink': {},
  'handleless_red': {},
  'handleless_yellow': {},
  /* eslint-enable quote-props */
});
